import { render, staticRenderFns } from "./PhoneSelect.vue?vue&type=template&id=4f982c54&scoped=true"
import script from "./PhoneSelect.vue?vue&type=script&lang=js"
export * from "./PhoneSelect.vue?vue&type=script&lang=js"
import style0 from "./PhoneSelect.vue?vue&type=style&index=0&id=4f982c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f982c54",
  null
  
)

export default component.exports